{
  "title": "अपना स्थान साझा करने से चेक-इन प्रक्रिया तेज होती है",
  "body": "हमें खेद है, लेकिन आपके स्थान तक पहुंच के बिना हम आपका चेक-इन पूरा नहीं कर सकते। जारी रखने के लिए कृपया स्थान पहुंच की अनुमति दें। हम केवल वेयरहाउस चेक-इन के उद्देश्यों के लिए आपके स्थान का उपयोग करते हैं और तृतीय पक्षों के साथ आपकी स्थान जानकारी संग्रहीत या साझा नहीं करते।",
  "shareLocation": "मेरा स्थान साझा करें"
}
